import connect from "../../../shared/data-store/connect";
import { ACTION_TOGGLE_CANCELATION_FILTER, store } from "./DataStore";
import { track } from "../../tracker/EventTracker";
import CancelationFilter from "../CancelationFilter";

customElements.define(
	"esc-favorites-cancelation-filter",
	class extends connect(CancelationFilter, store) {
		update({ filters }) {
			this.render(filters.cancelation);
		}

		onChange(event) {
			const { checked } = event.target;
			this.dispatchAction(ACTION_TOGGLE_CANCELATION_FILTER, checked);

			track(
				"Filter (Merkliste)",
				"Preis Filter",
				`Kostenlose Stornierung${checked ? "" : " entfernen"}`,
			);
		}
	},
);
